(function(){
	'use strict';
	angular.module('app.setup')
		.controller('alertUsersCtrl', alertUsersCtrl);

	alertUsersCtrl.$inject = ['$scope', '$timeout', '$uibModal', '$rootScope', 
		'tableService', 'leanFilterService', 'manageEmailAlertsService', 'tableRenderService', 'storeService'];

	function alertUsersCtrl($scope, $timeout, $uibModal, $rootScope, 
			tableService, leanFilterService, manageEmailAlertsService, tableRenderService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var rendererParams = {'factoryNdx': adminConfig.factory.id};
		var reportSettingsName = 'ManageEmailAlerts';
		var reportSettingsId;

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}

		var extraParams = [{}];
		var noPaging = true;
		
		var defaultFilters = [{
			'id': 'alert',
			'values': ['EarlyDelivery']
		}];

		$scope.$on('updateNoneSelected', function(event, args) {
			vm.noneSelected = args.noneSelected;
		});

		function setUrl() {
			var url = '{0}' + '/AlertSubscription/Type/';
			var aType = $scope.$parent.filterService.getSelectedIds('alert')[0] + '/Users';
			return url + aType;
		}

		function unsubscribeSelected() {
			$scope.$broadcast('unsubscribeSelected', { type: 'userNdx', factory: adminConfig.factory.id });
		};

		function subscribeModal() {
			var modalScope = $scope.$new();
			modalScope.selected = {};
			modalScope.selected.users = [];
			var alertType = leanFilterService.getSelectedIds('alert')[0];
			manageEmailAlertsService.getUnsubscribed(alertType, 'Users', adminConfig.factory.id)
				.then(function (data) {
					modalScope.users = data;
				});

			modalScope.add = function () {
				var userList = [];
				angular.forEach(modalScope.selected.users, function (user) {
					userList.push(user.userNdx);
				});
				$scope.$broadcast('changeSubscription', { subscribe: true, list: userList.toString(), type: 'userNdx', factory: adminConfig.factory.id });
				instance.close();
				modalScope.$destroy();
			};

			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/setup/subscribe_users.html'
			};

			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function () {
				instance.close();
				modalScope.$destroy();
			};
		};

		var columns = [{
			'id': 'isChecked',
			'display': '$checkbox',
			'customHeaderClass': 'checkboxCell alignCenter',
			'renderer': tableRenderService.checkboxRenderer,
			'sort': false,
			'hideMenu': true,
			'width': 45
		},
		{
			'id': 'name',
			'display': 'Name',
			'sort': false,
			'hideMenu': true,
			'width': 200
		},
		{
			'id': 'username',
			'display': 'Username',
			'sort': false,
			'hideMenu': true,
			'width': 200
		},
		{
			'id': 'role',
			'display': 'Role',
			'sort': false,
			'hideMenu': true,
			'width': 200
		},
		{
			'id': 'conditions',
			'display': 'Conditions (Buyers Only)',
			'renderer': tableRenderService.conditionsRenderer,
			'sort': false,
			'hideMenu': true,
			'columnText': 'Only parts for this buyer',
			'width': 300
		}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: setUrl(),
			noPaging: noPaging,
			columns: columns,
			pinnedColumns: [],
			defaultFilters: defaultFilters,
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			hideFiltersContainer: true,
			hideNoResultsSuggestion: true,
			hasTabs: true,
			setColumnDefaults: true,
			isGlobalReportSetting:true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.unsubscribeSelected = unsubscribeSelected;
		vm.subscribeModal = subscribeModal;
		vm.noneSelected = true;
	
		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			var url = setUrl();
			params.url = url;
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		init();

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = false;
			$scope.filterService.useAdminFactory = true;
			$scope.filterService.setMasterSingleSelectFilterList([
				$scope.filterService.filterDefinitions['AlertType']
			]);
		}
	};
})();